import { useEffect, useState } from "react";
import { Select } from "antd";
import RentalsService from "../../../services/rentals.service";

export default function TaskPropertyPicker({ ids, onChange, rentals, onSearch,
  maintenance, disabled, allRentals, onAllRentalsChange, recurring, error }) {
  const [known, setKnown] = useState({});
  useEffect(() => {
    setKnown((previous) => ({ ...previous, ...Object.fromEntries(
      (rentals || []).map((rental) => [Number(rental.rental_id), rental])
    ) }));
  }, [rentals]);
  useEffect(() => {
    let cancelled = false;
    ids.filter((id) => !known[id]).forEach((id) => {
      RentalsService.getRental(id).then((response) => {
        if (!cancelled && response?.data?.rental_id) {
          setKnown((previous) => ({ ...previous, [id]: response.data }));
        }
      }).catch(() => {}); // Selected IDs remain visible even if details are unavailable.
    });
    return () => { cancelled = true; };
    // Hydrate only when the selection changes; search results can be paginated.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids.join(",")]);
  const options = [...new Set([...(rentals || []).map((r) => Number(r.rental_id)), ...ids])]
    .map((id) => {
      const rental = known[id] || rentals?.find((r) => Number(r.rental_id) === id);
      return { value: id, label: rental
        ? [rental.pms_id || rental.name || `Property ${id}`, rental.address].filter(Boolean).join(", ")
        : `Property ${id}`,
      disabled: maintenance && ids.length >= 1 && !ids.includes(id) };
    });
  return <>
    {recurring && (!maintenance || allRentals) && <label className="uk-display-block uk-margin-small-bottom">
      <input type="checkbox" className="uk-checkbox" checked={allRentals} disabled={disabled}
        onChange={(event) => onAllRentalsChange(event.target.checked)} /> All properties (including future properties)
    </label>}
    <Select id="work-order-properties" aria-label="Properties" mode="multiple" showSearch allowClear
      style={{ width: "100%" }} value={ids} options={options}
      disabled={disabled || allRentals} onChange={onChange} onSearch={onSearch}
      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
      placeholder={maintenance ? "Select one property" : "Search and select properties"}
      aria-invalid={!!error} aria-describedby={error ? "work-order-properties-error" : undefined} />
    <div className="uk-text-meta uk-margin-small-top">
      {allRentals ? "All account properties selected" : `${ids.length} ${ids.length === 1 ? "property" : "properties"} selected`}
      {maintenance ? ". Maintenance requires one property." : recurring
        ? ". Each property has its own task occurrence. Series changes apply across these properties."
        : ". Saves a separate task for each property; saved tasks are edited individually."}
    </div>
    {error && <div role="alert" id="work-order-properties-error" className="uk-text-danger uk-margin-small-top">{error}</div>}
  </>;
}
